import { render, staticRenderFns } from "./chemistry.vue?vue&type=template&id=06d71df8&scoped=true"
import script from "./chemistry.vue?vue&type=script&lang=js"
export * from "./chemistry.vue?vue&type=script&lang=js"
import style0 from "./chemistry.vue?vue&type=style&index=0&id=06d71df8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d71df8",
  null
  
)

export default component.exports